// 快速把obj1里面对应的数据复制到obj2
export default function objCopy(obj1: any, obj2: any) {
  Object.keys(obj2).forEach(key => {
    obj2[key] = obj1[key]
  })
}
export function unique1(arr: any, val: any) {
  const res = new Map()
  return arr.filter((item: any) => !res.has(item[val]) && res.set(item[val], 1))
}
